import { ForwardTradeHistoryView } from "./forward-trade-history-view";
import { useForwardTradeHistory } from "./use-forward-trade-history";

export const ForwardTradeHistory = () => {
  const logic = useForwardTradeHistory();

  return <ForwardTradeHistoryView {...logic} />;
};
